module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', [_vm._v("Warning")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    on: {
      "click": _vm.warningConfirm
    }
  }, [_vm._v("Warning")])], 1), _vm._v(" "), _c('h3', [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    on: {
      "click": _vm.successConfirm
    }
  }, [_vm._v("Success")])], 1), _vm._v(" "), _c('h3', [_vm._v("Error")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-button', {
    on: {
      "click": _vm.errorConfirm
    }
  }, [_vm._v("Error")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "style"
  }, [_c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height427"
  }, [_c('img', {
    attrs: {
      "src": _vm.warningColor,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height427"
  }, [_c('img', {
    attrs: {
      "src": _vm.successColor,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height427"
  }, [_c('img', {
    attrs: {
      "src": _vm.errorColor,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h3', [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height427"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizing,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('h3', [_vm._v("Position")]), _vm._v(" "), _c('div', {
    staticClass: "position mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.position,
      "alt": ""
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Confirm")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Buttons bar: #F6F7FA")]), _vm._v(" "), _c('p', [_vm._v("Icon: #FFC107")]), _vm._v(" "), _c('p', [_vm._v("Button: #FFC107")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtle button: #485464 opacity 80% ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Buttons bar: #F6F7FA")]), _vm._v(" "), _c('p', [_vm._v("Icon: #00C853")]), _vm._v(" "), _c('p', [_vm._v("Button: #055AFE")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtle button: #485464 opacity 80% ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Buttons bar: #F6F7FA")]), _vm._v(" "), _c('p', [_vm._v("Icon: #00C853")]), _vm._v(" "), _c('p', [_vm._v("Button: #055AFE")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtle button: #485464 opacity 80% ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Corner radius: 4px")]), _vm._v(" "), _c('p', [_vm._v("Width: 400px")]), _vm._v(" "), _c('p', [_vm._v("Height: auto")]), _vm._v(" "), _c('p', [_vm._v("border: 0.5px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 18px")]), _vm._v(" "), _c('p', [_vm._v("Line height: 26px")]), _vm._v(" "), _c('p', [_vm._v("Font size(sentence): 16px")]), _vm._v(" "), _c('p', [_vm._v("Line height(sentence): 24px")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d61d9a8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
// module id = sUUl
// module chunks = 0